// =========================================================================
// ROBUST SECTION MOVE LOGIC (Replacing unreliable MutationObserver)
// This function checks repeatedly for the custom product section and the 
// app sidebar, ensuring the move executes successfully regardless of 
// theme speed optimization or loading order.
// =========================================================================

/**
 * Function to repeatedly check for the elements and move the section.
 * @param {number} maxRetries - The maximum number of times to check (e.g., 200 checks = 10 seconds total).
 * @param {number} currentRetry - Counter for current check iteration.
 */
function moveProductInfo(maxRetries = 200, currentRetry = 0) {
  // If we've tried too many times, stop to prevent infinite loops.
  if (currentRetry >= maxRetries) {
    console.error("Move Failed: Max retries reached. Either .product-info-inject or .npc-sidebar .npc-sidebar-price-box was not found.");
    return;
  }
  
  // 1. SELECT THE SECTION TO MOVE (Your custom content: trust badges/accordions)
  const sectionToMove = document.querySelector(".product-info-inject"); 
  
  // 2. SELECT THE TARGET LOCATION (The app's sidebar price box)
  const sidebar = document.querySelector(".npc-sidebar .npc-sidebar-price-box"); 
  
  // Check if both elements are now available in the DOM
  if (sectionToMove && sidebar) {
    // Both found: Perform the move
    // 'afterend' places the element immediately after the sidebar price box.
    sidebar.insertAdjacentElement("afterend", sectionToMove);
    console.log("SUCCESS: .product-info-inject section moved successfully on the new theme.");
    return; // Stop the function/loop
  }

  // If elements are missing, try again in 50 milliseconds.
  setTimeout(() => {
    moveProductInfo(maxRetries, currentRetry + 1);
  }, 50);
}

// Start the continuous check as soon as the main page structure is ready
document.addEventListener('DOMContentLoaded', () => {
  moveProductInfo();
});